var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"lc-color-picker-cancel",attrs:{"type":"button"},on:{"click":_vm.action}},[_vm._v("\n    Cancel\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }